import axios from 'axios'

export const getQuestions = (token, type, start = 0, limit = 10) => 
    axios.get(`discussion/questions/${type}/${token}/${start}/${limit}`)


export const getAnswers = (question, start = 0, limit = 1000) => 
    axios.get(`discussion/answers/${question}/${start}/${limit}`)

export const newAnswer = (question, content) => 
    axios.post(`discussion/new_answer/${question}`, {
        content
    })

export const newQuestion = (token, type, content, privacity) => 
    axios.post(`discussion/new_question/${type}/${token}`, {
        content,
        privacity
    })

export const deleteAnswer = (id) => 
    axios.post(`discussion/delete_answer/${id}`)

export const deleteQuestion = (id) => 
    axios.post(`discussion/delete_question/${id}`)




// WEBPACK FOOTER //
// ./src/utils/discussion.js